const NEGATIVE_CHAR = '-';
const STICKY_CHAR = '*';

const INCLUDE_ACTION = 'include';
const EXCLUDE_ACTION = 'exclude';

const SHORT_TRUTHY_STRING = '1';
const TRUTHY_STRINGS = ['true', SHORT_TRUTHY_STRING];
const SHORT_FALSY_STRING = '0';
const FALSY_STRINGS = ['false', SHORT_FALSY_STRING];

const DEPART_DIRECTION_KEY = 'd';
const RETURN_DIRECTION_KEY = 'r';

const DIRECT_TRIPS_ONLY_KEY = 'd'; // oneOf("true", "false", 0, 1)
const TIMING_KEY = 't'; // 0-24,0-24|0-24,0-24
const TIMING_DELIMITER = '|';
const FEATURES_KEY = 'f'; // comma seperated list of feature_ids e.g. feature_id1,feature_id2,...
const CARRIERS_KEY = 'c'; // comma seperated list of carrier_ids e.g. carrier_id1,carrier_id2,...
const ALLOW_NEARBY_KEY = 'n'; // oneOf("true", "false", 0, 1)
const TRAVEL_MODES_KEY = 'm'; // comma seperated list of travel modes e.g. "bus", "train", "ferry", "auto"
const SORT_TYPE_KEY = 's'; // oneOf('recommended', 'fastest','cheapest','earliest','latest')
const STATIONS_KEY = 'a'; // comma seperated list of station_ids e.g. station_id1,station_id2
const STATIONS_DELIMITER = '|';

const PARSED_FILTERS_NOT_TO_COPY = ['timing'];

export {
    ALLOW_NEARBY_KEY,
    CARRIERS_KEY,
    DEPART_DIRECTION_KEY,
    DIRECT_TRIPS_ONLY_KEY,
    EXCLUDE_ACTION,
    FALSY_STRINGS,
    FEATURES_KEY,
    INCLUDE_ACTION,
    NEGATIVE_CHAR,
    PARSED_FILTERS_NOT_TO_COPY,
    RETURN_DIRECTION_KEY,
    SHORT_FALSY_STRING,
    SHORT_TRUTHY_STRING,
    SORT_TYPE_KEY,
    STATIONS_DELIMITER,
    STATIONS_KEY,
    STICKY_CHAR,
    TIMING_DELIMITER,
    TIMING_KEY,
    TRAVEL_MODES_KEY,
    TRUTHY_STRINGS,
};
